{
  "version": 1,
  "asset_id": "b5ec153f-7d74-4085-9727-238795221405",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/b5ec153f-7d74-4085-9727-238795221405/clip-img_0047-poster-sm.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/b5ec153f-7d74-4085-9727-238795221405/clip-img_0047-poster-sm.webp",
  "original_filename": "clip-img_0047-poster-sm.webp",
  "size": 10240,
  "content_type": "image/webp",
  "created_at": "2026-08-01T21:10:11Z"
}
